import { Pipe, PipeTransform } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, filter, map } from 'rxjs';
import { IFiscalYear } from 'src/app/setting/models/fiscal-year';
import { AppStateInterface } from 'src/app/stores/global/appState.interface';
import { getFiscalYears, fiscalYearsSelector } from 'src/app/stores/global/fiscal-years/fiscal-years.store';

@Pipe({
    name: 'fiscalYear',
    standalone: false
})
export class FiscalYearPipe implements PipeTransform {
  constructor(
    private store: Store<AppStateInterface>
  ) {
    this.store.dispatch(getFiscalYears())
  }

  transform(fiscalYearId: string): Observable<IFiscalYear> {
    return this.store.pipe(select(fiscalYearsSelector)).pipe(
      filter((fiscalYear) => fiscalYear.length > 0),
      map((fiscalYears) =>
        fiscalYears.find((fiscalYear) => fiscalYear.id === fiscalYearId)
      )
    );
  }

}
